import resChart from "./res-chart";
import { barOptions } from "./common/defaultOptions";
import chartMixin from "./mixins/chart";
export default {
  name: "res-chart-bar",
  components: {
    resChart
  },
  mixins: [chartMixin],
  props: {
    option: {
      type: Object,
      default: () => {
        return barOptions;
      }
    }
  }
};